import { Pivot, PivotItem, Stack, Text } from 'office-ui-fabric-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { CommandBarButton } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import './ComplianceView.scss';
import { MyContext } from '../../context';
import PolicyRules from './PolicyRules/PolicyRules';
import Policies from './Policy/Policies';
import PatternDetection from './PatternDetection/PatternDetection';
import CategoryWrapper from '../RuleSetter/CategoryWrapper';
import AdherencePhrases from './AdherencePhrases/AdherencePhrases';
import AIAdherencePhrases from './AIAdherencePhrases/AIAdherencePhrases';
import AIQuestions from './AIQuestion/AIQuestions';
import AICategorization from './AICategorization/AICategorization';
import AIQualityManagement from './AIQualityManagement/AIQualityManagement';
import AIAssistants from './AIAssistant/AIAssistants';
import AIAssistantIcon from './AIAssistant/AIAssistantIcon';
import ContentUnderstanding from './ContentUnderstanding/ContentUnderstanding';

// Styles definition
const stackContainerStyles = {
    root: {
        paddingTop: 50
    }
};
const stackStyles = {
    root: {
        maxWidth: 660,
        marginBottom: 50
    }
};
const stackTokens = { childrenGap: 5 };


export default class ComplianceView extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        const hasFullCompliance = props.userRules?.addOnCompliance || props.userRules?.license === "10";
        this.state = {
            helpPanel: false,
            query: 0,
            openPolicyTrigger: "adherence",
            selectedKey: hasFullCompliance ? "Policies" : "aiQuestions"
        };
        this.data = null;
    }


    getPivotSelectAdherencePhrase = () => {
        let option = [
            {
                "key": 'adherencephrases',
                "text": this.context.getTranslation("compliance", "AdherencePhrases"),
                "iconProps": { iconName: "EntitlementRedemption" },
                "onClick": () => this.setState({ openPolicyTrigger: 'adherence', selectedKey: "policyRuleTrigger" })
            },
            {
                "key": 'aiadherencephrases',
                "text": this.context.getTranslation("compliance", "AIAdherencePhrases"),
                "iconProps": { iconName: "EntitlementRedemption" },
                "onClick": () => this.setState({ openPolicyTrigger: 'aiadherence', selectedKey: "policyRuleTrigger" })
            },
            ...(this.props.userRules.ruleAccess.userComplianceAIQuestions ? [{
                key: 'aiQuestions',
                text: this.context.getTranslation("compliance", "AIQuestions"),
                "iconProps": { iconName: "EntitlementRedemption" },
                onClick: () => this.setState({ openPolicyTrigger: 'aiquestions', selectedKey: "policyRuleTrigger" })
            }] : []),
            {
                "key": 'categories',
                "text": this.context.getTranslation("compliance", "categoriesTabName"),
                "iconProps": { iconName: "UserGauge" },
                "onClick": () => this.setState({ openPolicyTrigger: 'categories', selectedKey: "policyRuleTrigger" })
            },
            {
                "key": 'patterns',
                "text": this.context.getTranslation("compliance", "patternsTabName"),
                "iconProps": { iconName: "NumberSequence" },
                "onClick": () => this.setState({ openPolicyTrigger: 'patterns', selectedKey: "policyRuleTrigger" })
            }
        ]

        const optionTypePattern = {
            items: option,
            directionalHintFixed: true,
        };

        return (
            <div className="compliance-pivot-link">
                <Icon iconName={"EntitlementRedemption"} />
                <span>{this.context.getTranslation("compliance", "PolicyRulesTriggers")}</span>
                <CommandBarButton
                    className="compliance-pivot-menu"
                    styles={{ root: {} }}
                    disabled={false}
                    checked={false}
                    menuProps={optionTypePattern}
                />
            </div>)
    }

    getPivotAiAssistant = () => {
        return (
            <div className="compliance-pivot-link">
                <AIAssistantIcon height="16px" color="black" theme={this.props.theme} />
                <span>{this.context.getTranslation("compliance", "aIAssistant")}</span>
            </div>
        )
    }
    getPivotContentUnderstanding = () => {
        return (
            <div className="compliance-pivot-link">
                <Icon iconName={"ReceiptTentative"} />
                <span>{this.context.getTranslation("compliance", "contentUnderstanding")}</span>
            </div>
        )
    }

    /*getPivotPolicies = () => {
        return (
            <div style={{ marginRight: "0px", paddingRight: "0px", display: "contents" }} >
                <div>
                    <Icon style={{ padding: "7px", cursor: "pointer" }} iconName={"Shield"} />
                    <span>{this.context.getTranslation("compliance", "policiesTabName")}</span>
                </div>
                <Icon style={{ padding: "0px", margin: "0px", marginLeft: "15px" }} iconName={"Separator"} />
            </div>)
    }*/

    render() {
        const hasFullCompliance = this.props.userRules?.addOnCompliance || this.props.userRules?.license === "10";
        return (
            window.innerWidth > 750 ?
                <div>
                    <header className="app-header ms-Grid-row" style={{ backgroundColor: this.props.theme.palette.neutralLighterAlt, boxShadow: Depths.depth8 }} >
                        {hasFullCompliance ? (
                        <Pivot className="compliance-pivot" selectedKey={String(this.state.selectedKey)} aria-label="compliance-navbar" linkSize="large" onLinkClick={(e) => { this.setState({ selectedKey: e.props.itemKey }) }}>
                            <PivotItem
                                itemKey="Policies"
                                headerText={this.context.getTranslation("compliance", "policiesTabName")}
                                itemIcon="Shield"
                                headerButtonProps={{
                                    'style': { 'border-right': '1px solid #bcbcbc', 'padding-right': "10px" }
                                }}
                            >
                                <Policies theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} iconView={this.props.iconView} userRules={this.props.userRules} />
                            </PivotItem>
                            <PivotItem itemKey="PolicyRules" headerText={this.context.getTranslation("compliance", "policyRulesTabName")} itemIcon="TaskManager">
                                <PolicyRules theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
                            </PivotItem>
                            <PivotItem itemKey="policyRuleTrigger" onRenderItemLink={this.getPivotSelectAdherencePhrase} >
                                {this.state.openPolicyTrigger == "adherence" && <AdherencePhrases theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />}
                                {this.state.openPolicyTrigger == "aiadherence" && <AIAdherencePhrases theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />}
                                {this.state.openPolicyTrigger == "aiquestions" && <AIQuestions theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />}
                                {this.state.openPolicyTrigger == "categories" && <CategoryWrapper authorization={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} theme={this.props.theme} fromCompliance={true} />}
                                {this.state.openPolicyTrigger == "patterns" && <PatternDetection theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />}
                            </PivotItem>
                            {this.props.userRules.addOnQualityManagement && this.props.userRules.ruleAccess.userComplianceQM &&
                                <PivotItem itemKey="QM" headerText={this.context.getTranslation("compliance", "AIQM")} itemIcon="TrackersMirrored">
                                    <AIQualityManagement apol={this.props.apol} auth={this.props.authorization} userRules={this.props.userRules} theme={this.props.theme} />
                                </PivotItem>
                            }
                            <PivotItem itemKey="Cat" headerText={this.context.getTranslation("compliance", "categorizationTabName")} itemIcon="EntitlementRedemption" >
                                <AICategorization authorization={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} theme={this.props.theme} />
                            </PivotItem>
                            {this.props.userRules.ruleAccess.userComplianceAIAssistant &&
                                <PivotItem onRenderItemLink={this.getPivotAiAssistant} itemKey="AIAssistants" >
                                    <AIAssistants theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
                                </PivotItem>}
                            {this.props.userRules.ruleAccess.userComplianceAIAssistant &&
                                <PivotItem onRenderItemLink={this.getPivotContentUnderstanding} itemKey="ContentUnderstanding" >
                                    <ContentUnderstanding theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
                                </PivotItem>
                            }
                        </Pivot>
                        ) : (
                        <Pivot className="compliance-pivot" selectedKey={String(this.state.selectedKey)} aria-label="compliance-navbar" linkSize="large" onLinkClick={(e) => { this.setState({ selectedKey: e.props.itemKey }) }}>
                            <PivotItem onRenderItemLink={this.getPivotContentUnderstanding} itemKey="ContentUnderstanding" >
                                <ContentUnderstanding theme={this.props.theme} auth={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
                            </PivotItem>
                        </Pivot>
                        )}
                    </header>
                </div>
                :
                <div>
                    <Stack tokens={stackTokens}>
                        <Stack horizontalAlign="center" styles={stackContainerStyles}>
                            <Stack styles={stackStyles}>
                                <Text variant="xxLarge">{this.context.getTranslation("compliance", "frameToSmallTitle")}</Text>
                                <Text variant="xLarge">{this.context.getTranslation("compliance", "frameToSmallText")}</Text>
                            </Stack>
                        </Stack>
                    </Stack>
                </div>
        )
    }







}
